import { Component, OnInit, Input } from '@angular/core';

import { MarvColor, MarvColorPrimary } from '@marv/types';

function toStringInput(value: any): string{
    return value.toString();
}

@Component({
    selector: 'app-store-details-kpi',
    templateUrl: './kpi.component.html',
    styleUrls: ['./kpi.component.scss'],
})
export class StoreDetailsKpiComponent  implements OnInit {

    @Input({alias : 'label', required : true}) labelKpi: string;
    @Input({alias : 'value', required : true, transform: toStringInput}) valueKpi: string;
    @Input({alias : 'color', required : false}) colorKpi: MarvColor = MarvColorPrimary;

    constructor() { }

    ngOnInit() {}

}
